<script setup>
import { defineProps, onMounted } from "vue";
import UtilityInput from "@/components/Dashboard/Utilities/UtilityInput.vue";
import useUtilityInputsContainer from "@/scripts/Utilities/UtilityInputsContainer.js";

const props = defineProps({
  updateFieldObject: Function,
});

const { form, inputConfigs, resetForm } = useUtilityInputsContainer(props);

onMounted(() => {
  resetForm();
});
</script>

<template>
  <template v-for="(ui, key) in inputConfigs" :key="key">
    <UtilityInput
      :title="ui.title"
      :type="ui.type"
      :placeholder="ui.placeholder"
      v-model="form[key]"
    />
  </template>
</template>
